import './Presentation.css';

export default function PresentationPage({ onCatalog }) {
  return (
    <main className="presentation-page">
      <div className="presentation-decoration presentation-decoration-left" aria-hidden="true" />
      <div className="presentation-decoration presentation-decoration-right" aria-hidden="true" />

      <section className="presentation-card" aria-labelledby="presentation-title">
        <div className="presentation-mark" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        <p className="presentation-task">ЗАДАНИЕ 2</p>
        <h1 id="presentation-title">Санаториум<span>РФ</span></h1>
        <div className="presentation-divider" />
        <p className="presentation-team">Команда <strong>«Цыплята»</strong></p>
        <p className="presentation-university">КФ МГТУ им. Н.Э. Баумана</p>
        <button className="presentation-enter" type="button" onClick={onCatalog}>
          Перейти к сайту
          <span aria-hidden="true">↗</span>
        </button>
      </section>
      <div className="presentation-bottom-line" aria-hidden="true" />
    </main>
  );
}
